import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import WestRockLogo from '../WestRockLogo';

const useStyles = makeStyles({
	toolbar: {
		justifyContent: 'center',
	},
});

function WestRockHeader(props) {
	const classes = useStyles(props);
	const theme = useTheme();

	return (
		<AppBar
			position="static"
			color="inherit"
			style={{ backgroundColor: theme.palette.grey[100] }}
			elevation={0}
		>
			<Toolbar variant="dense" className={classes.toolbar}>
				<WestRockLogo />
			</Toolbar>
		</AppBar>
	);
}

export default WestRockHeader;
